import {ENDPOINT_POSTS} from "./api_post";
import {ENDPOINT_POST_OPTIONS} from "./api_post_options";
import {deleteObject, postObject} from "./api_common";

export const ENDPOINT_POST_POST_OPTIONS = '/api/post_post_options'

export function postPostPostOption(postId, postOptionId) {
    let url = process.env.REACT_APP_API_URL + ENDPOINT_POST_POST_OPTIONS
    let postData = {
        post: ENDPOINT_POSTS + '/' + postId,
        postOption: ENDPOINT_POST_OPTIONS + '/' + postOptionId
    }
    return postObject(url, postData)
}

export function deletePostPostOption(postPostOptionsId) {
    let url = process.env.REACT_APP_API_URL + ENDPOINT_POST_POST_OPTIONS + '/' + postPostOptionsId
    return deleteObject(url)
}
